"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _require = require("../../utils"),
    mixin = _require.mixin;

var SVGListBase = require("./SVGListBase");

var SVGStringListImpl = function SVGStringListImpl(args, privateData) {
  _classCallCheck(this, SVGStringListImpl);

  this._initList(privateData);
};

mixin(SVGStringListImpl.prototype, SVGListBase.prototype);
exports.implementation = SVGStringListImpl;